export default "__VITE_ASSET__BlzMICNo__"